/**
 * Validates form values against a set of validation rules
 * @param {Object} formValues - The current form values
 * @param {Array} validationRules - Rules from the component JSON
 * @returns {Object} - Object with field IDs as keys and error messages as values
 */
export const validateFormAgainstRules = (formValues, validationRules = []) => {
  const errors = {};
  
  // Check if formValues is undefined or null
  if (!formValues) {
    console.warn('formValues is undefined or null in validateFormAgainstRules');
    return errors;
  }
  
  if (!Array.isArray(validationRules) || validationRules.length === 0) return errors;
  
  validationRules.forEach(rule => {
    if (!rule) return;
    
    if (rule.type === 'notEqual') {
      if (!rule.fields || !Array.isArray(rule.fields) || rule.fields.length < 2) return;
      
      const [field1, field2] = rule.fields;
      if (!field1 || !field2) return;
      
      const value1 = formValues[field1];
      const value2 = formValues[field2];
      
      if (value1 && value2 && value1 === value2) {
        errors[field1] = rule.message || 'Values must be different';
        errors[field2] = rule.message || 'Values must be different';
      }
    }
    
    // New rule type: conditionalValue
    // If field1 equals value1, then field2 must equal value2
    else if (rule.type === 'conditionalValue') {
      // Skip invalid rules
      if (!rule.if || !rule.then) return;
      
      const { if: condition, then: requirement } = rule;
      
      // Skip if condition is invalid
      if (!condition || typeof condition.field !== 'string') return;
      
      // Safely access the field value
      const fieldValue = formValues[condition.field];
      
      // Only validate if the condition field has a value and matches the condition value
      if (fieldValue !== undefined && condition.value !== undefined && fieldValue === condition.value) {
        // Skip if requirement is invalid
        if (!requirement || typeof requirement.field !== 'string') return;
        
        // Safely access the target field value
        const targetFieldValue = formValues[requirement.field];
        
        // Check if the target field has the required value
        if (targetFieldValue !== requirement.value) {
          // Only add error to the target field (the one that needs to change)
          errors[requirement.field] = rule.message || 
            `This field is required when ${condition.field} is ${condition.value}`;
        }
      }
    }
    
    // Add more validation rule types as needed
  });
  
  return errors;
};
